import React from "react";
import "../../styles/DataTable.css";

export default function DataTable({
  columns,
  data,
  loading = false,
  emptyMessage = "No data found.",
  actions,
}) {
  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
            {actions && <th>Actions</th>}
          </tr>
        </thead>

        <tbody>
          {data.length > 0 ? (
            data.map((row, index) => {
              const rowKey = row?.id ?? row?.user_id ?? row?.client_id ?? row?.art_id ?? row?.token_id ?? index;
              return (
              <tr key={rowKey}>
                {columns.map((col) => (
                  <td key={col.key}>
                    {col.render
                      ? col.render(row[col.key], row)
                      : row[col.key]}
                  </td>
                ))}

                {actions && (
                  <td className="table-actions">
                    {actions(row)}
                  </td>
                )}
              </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={columns.length + (actions ? 1 : 0)}>
                {emptyMessage}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
